<template>
  <div :class="['layout', _isMobile() ? 'mobile' : '']">
    <Header3 id="header" />
    <router-view />
    <Footer id="footer" />
  </div>
</template>
  
  <script>
import { mixinDevice } from "@/utils/mixin.js";
import Banner from "@/components/header/Banner";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
export default {
  name: "FullScreenLayout",
  mixins: [mixinDevice],
  components: {
    Banner,
    Header3,
    Footer,
  },
  data() {
    return {};
  },
  created() {},
};
</script>
  <style>
a * {
  transition: all 0.1s ease;
}
</style>
  <style lang="less" scoped>
.layout {
  min-height: 100vh;
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(~@/assets/background.svg);

  #header,
  #footer {
    flex: 0 0 auto;
    position: relative;
    z-index: 10;
  }
}
</style>